module.exports = __webpack_public_path__ + "img/our_background1.5a8e94f0.png";